import React, { Component } from "react";
import { Icon, Segment } from "semantic-ui-react";
import ReactTable from "react-table";
import ReportFilters from "../../components/reports/ReportFilters";
import PageHeader from "../../components/PageHeader";
import _ from 'lodash';

import request from "../../utils/request";

const reportOptions = [
  {
    value: "/report/event-details",
    text: "Event Details",
  },
  {
    value: "/report/tickets",
    text: "Tickets",
  },
  {
    value: "/report/ticket-exception",
    text: "Ticket Exception"
  },
  {
    value: "/report/sellers",
    text: "Sellers"
  },
  {
    value: "/report/customers",
    text: "Customers"
  },
  {
    value: "/report/ticket-blocks",
    text: "Ticket Blocks"
  },
  {
    value: "/report/price-points",
    text: "Price Points"
  },
  {
    value: "/report/drum-log",
    text: "Drum Log"
  },
  {
    value: "/report/event-log",
    text: "Event Log"
  },
  {
    value: "/report/cash-drop",
    text: "Cash Drops"
  },
  {
    value: "/report/web-sales",
    text: "Web Sales"
  },
  {
    value: "/report/web-sales-exception",
    text: "Web Sales Exceptions"
  },
  {
    value: "/report/winners",
    text: "Winners"
  },
  {
    value: "/report/recipient",
    text: "Web Sales Recipients"
  },
  {
    value: "/report/beneficiary",
    text: "Beneficiary"
  },
  {
    value: "/report/audit",
    text: "Audit"
  },
  {
    value: "/report/version-history",
    text: "Version History"
  }
];
const salesBreakdown = [
  {
    Header: "Price Point",
    id: "amount",
    accessor: d => d.quantity + " for " + d.amount
  },
  {
    Header: "Count",
    accessor: "totalSets"
  },
  {
    Header: "Total Numbers",
    accessor: "totalTickets"
  },
  {
    Header: "Total Cost",
    accessor: "totalCost"
  },
  {
    Header: "% of Sales",
    accessor: "salesPC"
  },
  {
    Header: "% of Tickets",
    accessor: "ticketsPC"
  }
];
const CustomerData = [
  { Header: "first_name", accessor: "first_name" },
  { Header: "last_name", accessor: "last_name" },
  { Header: "email", accessor: "email" },
  { Header: "address", accessor: "address" },
  { Header: "city", accessor: "city" },
  { Header: "state", accessor: "state" },
  { Header: "zip_code", accessor: "zip_code" },
  { Header: "phone", accessor: "phone" },
  { Header: "phone_work", accessor: "phone_work" },
  { Header: "phone_home", accessor: "phone_home" },
  { Header: "subscribe_email", accessor: "subscribe_email" },
  { Header: "subscribe_text", accessor: "subscribe_text" },
  { Header: "age_range", accessor: "age_range" }
];
class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isMounted: false,
      apiEndpoint: null,
      eventOptions: [],
      eventIds: [],
      reportOptions: reportOptions,
      datesRange: "",
      pageSize: 100,
      page: 0,
      pages: -1,
      sorted: [],
      filtered: [],
      columns: [],
      data: [],      

    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchEvents();
  };
  fetchEvents = resp => {
    if (!resp) {
      this.setState({ isLoading: true });
      return request.get(
        this,
        "api:/event",
        {
          limit: 5000,
          sort: [{ id: "start_at", desc: true }]
        },
        this.fetchEvents
      );
    }
    let events = [];
    resp.data.map((value) => {
      if (value.is_test !== 1) {
        return events.push({
          text: value.title,
          value: parseInt(value.id)
        });
      }
    });
    this.setState({ isLoading: false, eventOptions: events });
    return true;
  };

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  }

  fetchData = () => {
    if (this.state.apiEndpoint === null) {
      this.setState({ isLoading: false });
      return;
    }
    if (this.state.eventIds.length === 0 && this.state.datesRange === "") {
      this.setState({ isLoading: false });
      return;
    }
    this.setState({ isLoading: true });

    let payload = {
      eventIds: this.state.eventIds,
      dateRange: this.state.datesRange,
      pageSize: this.state.pageSize,
      page: this.state.page + 1,
      sorted: this.state.sorted,
      filtered: this.state.filtered,
      export: 0
    };
    return request.post(this, this.state.apiEndpoint, payload)
      .then(resp => {
        this.handleData(resp);
       });
  };

  handleData = resp => {
    this.setState({
      isLoading: false
    });
    if (resp.data) {

      let columns = [];
      columns.push({
        expander: true,
        show:
          resp.data.length > 0 &&
          (typeof resp.data[0].sales !== "undefined" ||
            typeof resp.data[0].CustomerData !== "undefined"),
        Header: () => <strong>More</strong>,
        Footer: () => '',
        width: 65,
        Expander: ({ isExpanded, ...rest }) => (
          <div>
            {isExpanded ? (
              <Icon name="caret down" />
            ) : (
              <Icon name="caret right" />
            )}
          </div>
        ),
        style: {
          cursor: "pointer",
          fontSize: 25,
          padding: "0",
          textAlign: "center",
          userSelect: "none"
        }
      });

      for (let key in resp.headers) {
        if (key === 'gifted__recipients') {

          columns.push({
            Header: resp.headers[key],
            accessor: key,
            width: 250, // set this column statically since the string is html
            Cell: row => (
              <span>
                < div dangerouslySetInnerHTML={{
                  __html: row.value
                }}
                />
              </span>
            ),
            Footer: (resp.recordsAggregate && resp.recordsAggregate[key]) ? resp.recordsAggregate[key].toString() : ''
          });
        } else {
          columns.push({
            Header: resp.headers[key],
            accessor: key,
            width: this.getColumnWidth(resp.data, key, resp.headers[key]),
            minWidth: 90,
            Footer: (resp.recordsAggregate && resp.recordsAggregate[key]) ? resp.recordsAggregate[key].toString() : ''
          });
        }
      }
      
      this.setState({
        data: resp.data,
        columns: columns,
        pages: resp.last_page,// Math.ceil(resp.total / this.state.pageSize)            
      });
    }
  };

  getColumnWidth = (data, accessor, headerText) => {
    const cellLength = Math.max(
      ...data.map(row => {
        let value = '';
        if (typeof accessor === 'string') {
          value = _.get(row, accessor);
        } else {
          value = accessor(row);
        }
        if (typeof value === 'number') {
          return this.getTextWidth(value.toString());
        }
        return this.getTextWidth(value);
      }),
      this.getTextWidth(headerText)
    );
    const magicSpacing = 30;
    let ret = cellLength + magicSpacing;
    return ret < 60 ? 60 : ret;
  };

  getTextWidth = (text, font = "bold 12pt arial") => {
    // re-use canvas object for better performance
    var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement("canvas"));
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
  };

  fetchExport = req => {
    if (this.state.eventIds.length === 0 && this.state.datesRange === "") {
      this.setState({ isLoading: false });
      return;
    }
    this.setState({
      isLoading: true
    });
    let payload = {
      eventIds: this.state.eventIds,
      dateRange: this.state.datesRange,
      sorted: req.sorted ? req.sorted : this.state.sorted,
      filtered: req.filtered ? req.filtered : this.state.filtered,
      export: 1
    };
    return request.download(this, this.state.apiEndpoint, payload).then(resp => {
      this.setState({ isLoading: false });
    });
  };

  handleReport = () => {

    this.setState({
      page: 0,
      pages: -1,
      sorted: [],
      filtered: [],
      data: [],
      columns: [],
      pageJump: false
    }, () => this.fetchData());
  }

  render() {
    const { isLoading, data, columns, pageSize, pages, page } = this.state;
    return (
      <Segment basic>
        <PageHeader
          title={this.props.route.title}
          breadcrumbs={{
            key: "active",
            content: this.props.route.title,
            active: true
          }}
        />
        <ReportFilters
          currentState={this.state}
          change={this.handleChange}
          fetch={this.handleReport}
          download={this.fetchExport}
        />
        <ReactTable
          manual
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          resizable={true}
          filterable={false}
          defaultPageSize={20}
          defaultSorted={[{ id: "name", desc: false }]}
          pageSize={pageSize}
          sorted={this.state.sorted}
          resized={this.state.resized}
          minRows={0}
          pages={pages}
          page={page}
          showPagination={pages > 0 ? true : false}
          // Callbacks

          onSortedChange={sorted => this.setState({ sorted }, () => this.fetchData())}

          onPageChange={page => this.setState({ page }, () => this.fetchData())}
          onPageSizeChange={
            (pageSize, page ) => {     
                this.setState({ page, pageSize }, () => this.fetchData())                            
            }
          }

          SubComponent={row => {
            if (row.original.sales) {
              return (
                <div style={{ padding: "20px" }}>
                  <ReactTable
                    data={row.original.sales}
                    columns={salesBreakdown}
                    minRows={0}
                    resizable={false}
                    defaultPageSize={pageSize}
                    showPagination={false}
                  />
                </div>
              );
            }
            if (row.original.CustomerData) {
              if (row.original.CustomerData === null) row.original.CustomerData = [];
              return (
                <div style={{ padding: "20px" }}>
                  <ReactTable
                    data={row.original.CustomerData}
                    columns={CustomerData}
                    minRows={0}
                    resizable={false}
                    defaultPageSize={pageSize}
                    showPagination={false}
                  />
                </div>
              );
            }
            return false;
          }}
        />
      </Segment>
    );
  }
}

export default Report;
